import axios from 'axios';
import Api from '../api/ApiUrl'

const API_URL = `${Api}/api/v1`;
const config = {
  headers: {
      // Authorization: `Bearer ${Cookies.get('token')}`,
      role: 'admin'
  },
};
export const getCategories = async (params) => {
  const response = await axios.get(`${API_URL}/categories?page=${params.page}&limit=${params.limit}&sort=${params.sort}`,config);

  return response.data;
};

export const getCategoryById = async (id) => {
  console.log(id)
  const response = await axios.get(`${API_URL}/categories/${id}`,config);
  console.log(response)
  return response.data;
};

export const addCategory = async (category) => {
  const response = await axios.post(`${API_URL}/categories`, category,config);
  return response.data;
};

export const updateCategory = async (id, category) => {
  const response = await axios.put(`${API_URL}/categories/${id}`, category,config);
  return response.data;
};

export const deleteCategory = async (id) => {
  const response = await axios.delete(`${API_URL}/categories/${id}`,config);
  console.log(response)
  return response.data;
};

export const getSubcategories = async (params) => {
  console.log(params)
  const response = await axios.get(`${API_URL}/subcategory`, { params },config);
  return response.data;
};

export const getSubcategoryById = async (id) => {
  const response = await axios.get(`${API_URL}/subcategories/${id}`,config);
  return response.data;
};

export const addSubcategory = async (subcategory) => {
  const response = await axios.post(`${API_URL}/subcategory`, subcategory,config);
  return response.data;
};

export const updateSubcategory = async (id, subcategory) => {
  const response = await axios.put(`${API_URL}/subcategory/${id}`, subcategory, {
    headers: {
      'Content-Type': 'multipart/form-data',
      role: 'admin'

    },
  });
  return response.data;
};

export const deleteSubcategory = async (id) => {
  const response = await axios.delete(`${API_URL}/subcategories/${id}`,config);
  return response.data;
};
